import { type FC } from 'react';
import {
  CreditCard
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconCreditCardProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconCreditCard: FC<UiIconCreditCardProps> = (props) => {
  return (
    <UiIcon
      IconComponent={CreditCard}
      {...props}
    />
  );
};
